import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Grid } from '@mui/material'
import { object, string } from 'yup'

import { RESEND_ENDPOINTS, useVerifyLoginMutation } from '../../services'
import { FadeInWrapper, PageTitle, VerifyCodeField } from '../../components'
import { Form, FormSchema, FormSchemaMessages, SubmitButton, SubmitErrorMessage } from '../../components/form'
import { APP_ROUTES } from '../../constants.ts'
import { useLogin } from '@/stores/slices/user-slice.ts'

export interface VerifyLoginFormProps {
  handlePrevStage(): void
}

export interface VerifyLoginFormState {
  code: string
}

const verifyLoginFormSchema = object<FormSchema<VerifyLoginFormState>>({
  code: string().required(FormSchemaMessages.required),
})

export const VerifyLoginForm = ({ handlePrevStage }: VerifyLoginFormProps): React.ReactElement => {
  const login = useLogin()
  const { mutate, isError, isSuccess, error } = useVerifyLoginMutation(login)
  const navigate = useNavigate()

  const handleVerifyMutation = (formData: { code: string }) => {
    mutate(formData)
  }

  useEffect(() => {
    if (isSuccess) {
      navigate(APP_ROUTES.SbpPayments)
    }
  }, [isSuccess])

  return (
    <FadeInWrapper>
      <PageTitle
        title="Введите одноразовый код"
        onBack={handlePrevStage}
        description={`Вам был отправлен одноразовый код-подтверждение`}
      />
      <Form<VerifyLoginFormState>
        name="login_verify"
        onSubmit={handleVerifyMutation}
        validationSchema={verifyLoginFormSchema}
      >
        <Grid item container flexDirection="column" spacing={2}>
          <VerifyCodeField login={login} apiUrl={RESEND_ENDPOINTS.resendLoginCode} />
          <Grid item sx={{ mt: { xs: 4, lg: 6 } }}>
            <SubmitErrorMessage isError={isError} message={error?.response?.data?.errorMessage} />
            <SubmitButton>Подтвердить</SubmitButton>
          </Grid>
        </Grid>
      </Form>
    </FadeInWrapper>
  )
}
